<template>
  <div class="ll-classification-wrap">
    <p class="ll-classification-wrap_title">
      {{ $t(title) }}
    </p>
    <div
      class="ll-classification-wrap_content"
      :class="[{'bg-white':bgWhite}]"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlClassificationWrap",
  props: {
    title: {
      type: String,
      default: "",
    },
    bgWhite: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-classification-wrap";
</style>